import Vue from 'vue';
import Router from 'vue-router';
import index from '../pages/index.vue';
import Home from '../pages/Home';
import Construction from '../pages/Construction';
import Democratic from '../pages/Democratic';
import General from '../pages/General';
import ImporantNews from '../pages/ImporantNews';
import Proposer from '../pages/Proposer';
import Social from '../pages/Social';
import SpecialCommittee from '../pages/SpecialCommittee';
import CommitteeMember from '../pages/CommitteeMember';
import County from '../pages/County';
import History from '../pages/History'; 
import Inform from '../pages/Inform';
import Political from '../pages/Political';
import Stones from '../pages/Stones';
import Study from '../pages/Study';
import ThemeVideo from '../pages/ThemeVideo';
import Video from '../pages/Video';
import XuZhou from '../pages/XuZhou';
import pageDetails from '../pages/pageDetails.vue';
import PartyConstruction from '../pages/PartyConstruction.vue';//党风廉政
import MessageBoard from '../pages/MessageBoard.vue';//留言板
import CollectAdvice from '../pages/CollectAdvice.vue';//意见征集
import OnlineSearch from '../pages/OnlineSearch.vue';
import zxhyCom from "../pages/zxhy.vue";
import scdy from "../pages/scdy.vue"
Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/',
      name: '主页',
      component: Home,
      children: [
        {
          path: 'index',
          name: '首页',
          component: index
        },
        {
          path: 'construction',
          name: '机关建设',
          component: Construction
        },
        {
          path: 'democratic',
          name: '时政动态',
          component: Democratic
        },
        {
          path: 'general',
          name: '政协概况',
          component: General
        },
        {
          path: 'imporantnews',
          name: '政协要闻',
          component: ImporantNews
        },
        {
          path: 'proposer',
          name: '提案工作',
          component: Proposer
        },
        {
          path: 'social',
          name: '社情民意',
          component: Social
        },
        {
          path: 'specialCommittee',
          name: '专委会工作',
          component: SpecialCommittee
        },
        {
          path: 'committeemember',
          name: '委员天地',
          component: CommitteeMember
        },
        {
          path: 'county',
          name: '县区政协',
          component: County
        },
        {
          path: 'history',
          name: '以史资政',
          component: History
        },
        {
          path: 'inform',
          name: '通知公告',
          component: Inform
        },
        {
          path: 'political',
          name: '党派团体',
          component: Political
        },
        {
          path: 'stones',
          name: '他山之石',
          component: Stones
        },
        {
          path: 'study',
          name: '学习参考',
          component: Study
        },
        {
          path: 'themevideo',
          name: '专题视频',
          component: ThemeVideo
        },
        {
          path: 'video',
          name: '视频',
          component: Video
        },
        {
          path: 'xuzhou',
          name: '徐州政协',
          component: XuZhou
        },
        {
          path: 'pageDetails',
          name: '详情页面',
          component: pageDetails
        },
        {
          path: 'PartyConstruction',
          name: '党风廉政',
          component: PartyConstruction
        },
        {
          path: 'messageboard',
          name: '留言板',
          component: MessageBoard
        },
        {
          path: 'collectadvice',
          name: '意见征集',
          component: CollectAdvice
        },
        {
          path: 'OnlineSearch',
          name: '在线搜索',
          component: OnlineSearch
        },
        {
          path:"zxhy",
          name:"zxhy",
          component:zxhyCom
        },
        {
          path:"scdy",
          name:"视察调研",
          component:scdy
        },
        {
          path:"zhuanlan",
          name:"专题专栏",
          component:()=>import ("../pages/zhuanlan.vue")
        },
        // tupian
        {
          path:"tupian",
          name:"图片新闻",
          component:()=>import ("../pages/tupian.vue")
        },
        // mzdp
        {
          path:"mzdp",
          name:"民主党派",
          component:()=>import ("../pages/mzdp.vue")
        },
      ]
    }
  ]
});

router.beforeEach((to, from, next) => {
  // 让页面回到顶部
  document.documentElement.scrollTop = 0;
  // 调用 next()，一定要调用 next 方法，否则钩子就不会被销毁
  next();
});
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js